var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast",style:(`background-color: ${_vm.notification.type === 'success' ? '#76BA99' : '#EB4747'}`)},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.notification.text)))]),(_vm.notification.type)?_c('BaseIcon',{staticClass:"icon",attrs:{"icon":_vm.toastIcon,"color":"#fff"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }